"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _omit = _interopRequireDefault(require("lodash/omit"));

var _reactDesc = require("react-desc");

var _InputField = require("../../atoms/InputField");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var schema = (0, _reactDesc.describe)({
  displayName: 'Select'
});
schema.propTypes = _objectSpread({}, (0, _omit.default)(_InputField.schema.makePropTypes(), ['children', 'maxLength', 'onChange', 'showCharacterCount']), {
  clearButtonLabel: _reactDesc.PropTypes.string.description("A hidden label value for the clear button. The select component's label is available within the string for clarity.").defaultValue('Clear {label} value'),
  containerSelector: _reactDesc.PropTypes.string.description("A CSS selector to the element where the SelectDate should be rendered in, or \"parent\" to render the SelectDate in-place.").defaultValue('body'),
  defaultValue: _reactDesc.PropTypes.instanceOf(Date).description('The date should be selected by default.'),
  onChange: _reactDesc.PropTypes.func.description('Called with either the selected date or `undefined`'),
  onHide: _reactDesc.PropTypes.func.description('A callback which is triggered when the popover is closed'),
  onShow: _reactDesc.PropTypes.func.description('A callback which is triggered when the popover is opened'),
  value: _reactDesc.PropTypes.instanceOf(Date).description('The Date that is selected. If provided, controlling the SelectDate must be handled externally. Overrides `defaultValue`.'),
  disabledDateRules: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.array).description('An array of rules to disable dates. Every rule is an array itself containing the type of rule as first element followed by needed params to apply the rule'),
  zIndex: _reactDesc.PropTypes.number.description('Sets the z-index style property of the options list')
});
var _default = schema;
exports.default = _default;